



































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../../models/Application";
import { Product } from "../../viewmodels/Product";

@Component({})
export default class extends Vue {
  public collection = app.productCollection;
  public categoryCollection = app.categoryCollection;

  public search: string = "";
  public model: Product = new Product({}, this.collection);
  public selectedModel: Product | null = null;

  public dialog = false;
  public formTitle: string = "Product";

  public headers = [
    { text: "Name", value: "name" },
    { text: "Category", value: "category" },
    { text: "Price Regular", value: "price_regular" },
    { text: "Price Medium", value: "price_medium" },
    { text: "Price Large", value: "price_large" },
    { text: "Actions", value: "" }
  ];

  public rowsPerPageItems = [-1];
  public pagination = {
    rowsPerPage: -1
  };

  public mounted() {
    this.search = this.collection.search;
  }

  @Watch("search")
  public onSearchChange() {
    this.collection.doSearch(this.search);
    this.collection.refreshData();
  }

  public remove(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public close() {
    this.dialog = false;
  }

  public async save() {
    try {
      await this.model.save();
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public add() {
    this.model = new Product({}, this.collection);
    this.dialog = true;
  }

  public edit(item: Product) {
    this.model = item;
    this.dialog = true;
  }

  private async onFileSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/products/upload/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Image uploaded succesfully!"
      });
      app.refreshData();
    }
  }

   private async onFoodAudioSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/products/upload/audio/food/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Food audio uploaded succesfully!"
      });
      app.refreshData();
    }
  }

  private async onSideDishAudioSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/products/upload/audio/sidedish/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Side dish audio uploaded succesfully!"
      });
      app.refreshData();
    }
  }

  private async onDrinksAudioSelect(file: any) {
    if (file) {
      const response = await app.uploadService.upload(
        file,
        "/products/upload/audio/drinks/" + this.model.id
      );
      this.$store.dispatch("showSnackbar", {
        message: "Drinks audio uploaded succesfully!"
      });
      app.refreshData();
    }
  }
}
